import { ValidationError, validate } from 'class-validator';
import { ContratosUser } from './../entities/ContratosUser.entity';
import { Login } from './../entities/login.entity';
import { LoginTlf } from './../entities/loginTlf.entity';
import { Component, OnInit } from '@angular/core';
import { AlertBoxComponent } from '../shared/alertbox.component';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { Explotacion } from '../entities/explotacion.entity';
import { Respuesta } from '../entities/respuesta.entity';
import { environment } from '../../environments/environment';
import { UserServiceA2P } from '../services/userA2P.service';
import { FormatoTelefono } from '../entities/naciones';
import { HttpService } from '../services/http.service';
import { MensajeDmService } from '../services/mensaje-dm.service';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public title = 'Login';
  public messageBox: string;
  public alerts: Array<string> = [];
  public explotaciones: Explotacion[] = [];
  public selectedExplotacion: Explotacion = null;
  public resultado: Respuesta;
  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public user: Login = new Login();
  public telephoneUpdate: FormatoTelefono = new FormatoTelefono();
  public password: string;
  public usuario: string;
  public userAll: ContratosUser = new ContratosUser();
  public poblacionInputError: boolean;
  public usuarioInputError: boolean;
  public passwordInputError: boolean;
  public site: string;
  public pie: string;
  public connectionError: boolean;
  public showModalValidCod: boolean = false;
  public showModalValidTlf: boolean = false;
  public mostrarMensaje: boolean = false;
  public tituloMensaje: string;
  public mensaje: string;
  public timerMensaje: any;
  public hayLogin: boolean = true;
  public ESTADOS = { NV: 'NV', NDM: 'NDM', DM: 'DM', R: 'R', D: 'D' };
  public telefonoCorrecto: boolean = false;
  public onUsuarioChange(value: string) { this.usuario = (value || '').toUpperCase().replace(/\s+/g, ''); }
  public onMessageCabecera(evt: string) { this.messageCabecera = evt; }
  public onTypeException(evt: number) { this.typeException = evt; }
  public onMessageCompleto(evt: string) { this.messageComplet = evt; }
  private intentos: number = 0;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router, private userServiceA2P: UserServiceA2P, private httpService: HttpService, private mensajeDmService: MensajeDmService) { }

  ngOnInit() {
    this.mensajeDmService.ocultarMensaje();
    this.selectedExplotacion = null;
    this.sessionService.datosExplotacion = new Explotacion();
    this.sessionService.datosExplotacion.CondicionesEnvio = null;
    this.sessionService.datosExplotacion.PoliticaEnvio = null;
    this.userService.getExplotaciones().subscribe(
      response => this.cargarExplotaciones(response),
      error => this.cargarExplotacionesError(error)
    );
    this.clearInputErrors();
    this.site = environment.site;
    this.pie = environment.pie;
  }

  private cargarExplotaciones(response: any): void {
    this.connectionError = false;
    this.explotaciones = response;
    this.explotaciones = this.explotaciones.filter(e => e.Estado !== this.ESTADOS.NV);
    this.sessionService.Explotaciones = this.explotaciones;
    if (this.explotaciones.length === 1) {
      this.selectedExplotacion = this.explotaciones[0];
      this.sessionService.datosExplotacion = this.explotaciones[0];
      this.CambioPoblacion();
    }
  }

  private cargarExplotacionesError(error: any): void {
    this.connectionError = true;
    this.messageCabecera = 'No se ha podido establecer la conexión';
    this.messageComplet = 'La conexión ha fallado, presione F5 o actualice la página para tratar de solucionar el problema.';
    this.typeException = 1;
    AlertBoxComponent.changeMensaje.next(this.typeException);
  }

  public CambioPoblacion() {
    if (!this.selectedExplotacion) {
      this.sessionService.datosExplotacion = new Explotacion();
      this.sessionService.datosExplotacion.CondicionesEnvio = null;
      this.sessionService.datosExplotacion.PoliticaEnvio = null;
      return;
    }
    this.mostrarMensaje = false;
    this.hayLogin = true;
    const explotacion = this.selectedExplotacion;
    this.tituloMensaje = 'AVISO OV ' + explotacion.Codigo.toUpperCase();
    switch (explotacion.Estado) {
      case this.ESTADOS.NDM: {
        this.hayLogin = false;
        this.mensaje = explotacion.EstadoNoDisManMensaje;
        this.mostrarMensaje = true;
        break;
      }
      case this.ESTADOS.DM: {
        const ahora = new Date();
        const mensajeOriginal = explotacion.EstadoDisManMensaje;
        const inicioRaw = explotacion.EstadoDisManMenFechaInicio;
        const finRaw = explotacion.EstadoDisManMenFechaFin;
        let mensajeMostrar: string | null = null;
        if (!mensajeOriginal || mensajeOriginal.trim() === '') {
          mensajeMostrar = explotacion.Codigo + ' EstadoDisManMensaje está vacío.';
        } else if (!inicioRaw) {
          mensajeMostrar = explotacion.Codigo + ' EstadoDisManMenFechaInicio está vacía o nula.';
        } else if (!finRaw) {
          mensajeMostrar = explotacion.Codigo + ' EstadoDisManMenFechaFin está vacía o nula.';
        } else {
          const inicio = new Date(inicioRaw);
          const fin = new Date(finRaw);
          if (isNaN(inicio.getTime())) {
            mensajeMostrar = explotacion.Codigo + ' EstadoDisManMenFechaInicio inválida.';
          } else if (isNaN(fin.getTime())) {
            mensajeMostrar = explotacion.Codigo + ' EstadoDisManMenFechaFin inválida.';
          } else if (inicio > fin) {
            mensajeMostrar = explotacion.Codigo + ' EstadoDisManMenFechaInicio es mayor que EstadoDisManMenFechaFin.';
          } else {
            if ((inicio.getTime() === fin.getTime() && this.mismaFecha(ahora, inicio))) {
              mensajeMostrar = mensajeOriginal;
            } else {
              const mismoTiempoInicio = inicio.getHours() === 0 && inicio.getMinutes() === 0 && inicio.getSeconds() === 0;
              const mismoTiempoFin = fin.getHours() === 0 && fin.getMinutes() === 0 && fin.getSeconds() === 0;
              if (mismoTiempoInicio && mismoTiempoFin) {
                if (ahora >= inicio && ahora < new Date(fin.getTime() + 24 * 60 * 60 * 1000)) {
                  mensajeMostrar = mensajeOriginal;
                }
              } else {
                if (ahora >= inicio && ahora <= fin) {
                  mensajeMostrar = mensajeOriginal;
                }
              }
            }
            if (mensajeMostrar && fin > ahora && this.mismaFecha(ahora, fin)) {
              const tiempoRestante = fin.getTime() - ahora.getTime();
              clearTimeout(this.timerMensaje);
              this.timerMensaje = setTimeout(() => { this.mostrarMensaje = false; }, tiempoRestante);
            }
          }
        }
        if (mensajeMostrar) {
          this.mensaje = mensajeMostrar;
          this.mostrarMensaje = true;
        }
        break;
      }
      case this.ESTADOS.R: {
        const url = explotacion.EstadoRedireccionURL;
        if (!url) {
          this.hayLogin = false;
          this.mensaje = `${explotacion.Codigo}: OV_ESTADO_R_URL está vacía. Redirección cancelada.`;
          this.mostrarMensaje = true;
          break;
        }
        if (this.esUrlValida(url)) {
          this.selectedExplotacion = null;
          window.location.replace(url);
        } else {
          this.hayLogin = false;
          this.mensaje = `${explotacion.Codigo}: La URL de OV_ESTADO_R_URL no es válida. Redirección cancelada.`;
          this.mostrarMensaje = true;
        }
        break;
      }
      case this.ESTADOS.D: {
        this.sessionService.datosExplotacion = explotacion;
        break;
      }
      default: {
        this.sessionService.datosExplotacion = explotacion;
        break;
      }
    }
  }

  private esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  private mismaFecha(d1: Date, d2: Date): boolean {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  }

  private esHoy(hoy: Date, fecha: Date): boolean {
    return fecha.getFullYear() === hoy.getFullYear() && fecha.getMonth() === hoy.getMonth() && fecha.getDate() === hoy.getDate();
  }

  private mismaFechaHora(d1: Date, d2: Date): boolean {
    return d1.getTime() === d2.getTime();
  }

  public login($event) {
    this.clearInputErrors();
    this.user.UserName = this.usuario;
    this.user.Password = this.password;
    this.user.RememberMe = false;
    if (this.selectedExplotacion) {
      validate(this.user).then(resultado => {
        if (resultado.length > 0) {
          this.showErrors(resultado);
        } else {
          this.userService.login(this.selectedExplotacion.Codigo, this.user)
            .subscribe(
              response => this.loginOnSuccess(response),
              response => this.loginOnError(response)
            );
        }
      });
    } else {
      this.poblacionInputError = true;
    }
  }

  private loginOnSuccess(response: any) {
    this.sessionService.validacionA2P = response.LoginA2P;
    this.telefonoCorrecto = response.TelefonoCorrecto;
    this.sessionService.intentosCodigo = response.IntentosCodigo;
    this.sessionService.intentosReenvio = response.IntentosReenvio;
    this.userAll = response;
    this.sessionService.datosExplotacion = this.selectedExplotacion;

    if (this.sessionService.validacionA2P) {
      this.loginMFA();
    } else {
      this.completarInicioSesion();
    }
  }

  private navegacionLogin() {
    if (this.userAll.UsuarioOnline.PenultimoAcceso == null) {
      this.sessionService.isAuthenticated = false;
      this.sessionService.pendingChangePass = true;
      this.router.navigate(['/home/changePassword']);
    } else {
      this.router.navigate(['/home/home']);
    }
  }

  private loginMFA() {
    if (!this.telefonoCorrecto) {
      this.showModalValidTlf = true;
      this.showModalValidCod = false;
    }
    else {
      if (!this.telephoneUpdate)
        this.telephoneUpdate = Object.assign(new FormatoTelefono(), { CodigoTelefono: "", Numero: this.userAll.UsuarioOnline.Telefono1 });
      this.userServiceA2P.enviarCodSMS(this.userAll.UsuarioOnline.Telefono1).subscribe(
        () => this.showModalValidCod = true,
        response => this.loginOnError(response)
      );
    }
  }

  private loginOnError(response: any) {
    this.resultado = response;
    this.messageCabecera = 'Error en el acceso';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error al intentar acceder';
      this.typeException = 1;
    }
    AlertBoxComponent.changeMensaje.next(this.typeException);
    if (this.sessionService.isAuthenticated) {
      this.sessionService.logout();
    }
  }

  public async onSubmitModalTlf() {
    this.showModalValidTlf = false;
    this.httpService.hideSpinner();
    this.userServiceA2P.enviarCodSMS(this.telephoneUpdate.CodigoTelefono + '-' + this.telephoneUpdate.Numero).subscribe(
      () => this.showModalValidCod = true,
      response => this.loginOnError(response)
    );
  }

  public async onSubmitModalCod(response: any) {
    this.showModalValidCod = false;
    this.completarInicioSesion(true);
    this.httpService.hideSpinner();
  }

  private completarInicioSesion(guardarTelefono: boolean = false) {
    this.userService.getContratos().subscribe(
      contratos => {
        this.userAll.Contratos = contratos;
        this.sessionService.authenticated(this.userAll, this.explotaciones);

        const guardar$ = guardarTelefono ? this.guardarTlf() : null;
        if (!guardar$) {
          this.navegacionLogin();
          return;
        }

        guardar$.subscribe(
          () => {
            this.messageComplet =
              'Tu número de teléfono ha sido configurado correctamente para autenticación multifactor.';
            AlertBoxComponent.changeMensaje.next(2);
            this.navegacionLogin();
          },
          error => {
            this.loginOnError(error);
            this.closeModal();
          }
        );
      },
      error => {
        this.loginOnError(error);
        this.closeModal();
      }
    );
  }

  public updateTelephone(response: any) {
    this.telephoneUpdate = response;
  }

  public closeModal() {
    this.showModalValidCod = false;
    this.showModalValidTlf = false;
    this.sessionService.logout();
  }

  private clearInputErrors() {
    this.poblacionInputError = false;
    this.usuarioInputError = false;
    this.passwordInputError = false;
  }

  private showErrors(resultado: ValidationError[]) {
    for (const item of resultado) {
      switch (item.property) {
        case 'UserName':
          this.usuarioInputError = true;
          break;
        case 'Password':
          this.passwordInputError = true;
          break;
      }
    }
  }

  private guardarTlf() {
    if (this.telefonoCorrecto || !this.telephoneUpdate) {
      return null;
    }
    return this.userServiceA2P.guardarTlf(`${this.telephoneUpdate.CodigoTelefono}-${this.telephoneUpdate.Numero}`);
  }

  public reSendCode() {
    this.intentos += 1;
    if (this.intentos > this.sessionService.intentosReenvio) {
      this.messageComplet = 'Se han superado el numero de intentos de reenvío de código.';
      this.typeException = 1;
      this.showModalValidCod = false;
      this.intentos = 0;
      return;
    }
    this.loginMFA();
  }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/public/login.component.ts